import { FormTab, Group, GroupTitle } from "ra-friendsofbabba";

import DeliverableResultsField from "../fields/DeliverableResultsField";
import FinalOutputsField from "../fields/FinalOutputsField";
import HelpAlert from "../HelpAlert";
import ImpactsField from "../fields/ImpactsFIeld";
import { Input } from "../../component/input";
import KnowHowField from "../fields/KnowHowField";
import { useTranslate } from "react-admin";

const Section4Tab = ({ reportType, basePath, ...props }) => {
  const translate = useTranslate();
  return (
    <FormTab {...props} label="resources.technical-reports.tabs.section_4">
      <Group wrapper>
        <GroupTitle
          title={translate(
            `resources.technical-reports.title.section_4.${
              reportType <= 2 ? "2" : "3"
            }`
          )}
          subTitle={translate(
            `resources.technical-reports.help.section_4.${
              reportType <= 2 ? "2" : "3"
            }`
          )}
        />
      </Group>
      <br />
      {reportType < 3 && (
        <Input source="impacts" fullWidth component={<ImpactsField />} />
      )}
      {reportType > 2 && (
        <Input
          source="deliverable_results"
          fullWidth
          component={<DeliverableResultsField />}
        />
      )}
      {reportType > 2 && (
        <Input
          source="final_outputs"
          fullWidth
          component={<FinalOutputsField />}
        />
      )}

      {reportType > 2 && (
        <Input source="know_how" fullWidth component={<KnowHowField />} />
      )}
      {reportType > 2 && <HelpAlert />}
    </FormTab>
  );
};

export default Section4Tab;
